<template>
  <v-col cols="12" md="12" v-if="!show" class="px-0">
    <v-row>
      <v-col cols="12" md="10">
        <v-btn
          small
          depressed
          class="btn-filter mb-0 pb-0"
          cols="12"
          md="12"
          @click="show = true"
        >
          <v-icon small>mdi mdi-filter-outline</v-icon> Filtrer
        </v-btn>
      </v-col>
      <v-col cols="12" md="2" class="text-right">
        <!-- <v-select
          v-model="download_type"
          :items="download"
          label="Télécharger"
          solo
          small
          item-text="label"
          item-value="type"
          clearable
          prepend-inner-icon="mdi mdi-microsoft-excel"
          @change="applyDownload()"
        ></v-select> -->
        <v-btn
          @click="applyDownload()"
          small
          depressed
          class="btn-download mb-0 pb-0"
          cols="12"
          md="12"
          :loading="downloading"
        >
          <v-icon small>mdi mdi-microsoft-excel</v-icon> Télécharger CSV
        </v-btn>
      </v-col>
    </v-row>
  </v-col>

  <v-form v-else @submit.prevent="applyFilters" class="bg-white p-4 mb-4">
    <v-row>
      <v-col cols="12" md="12">
        <h5>Filtrer par :</h5>
      </v-col>

      <v-col cols="12" md="4" class="pb-0 mb-0">
        <h6>Réference / Numéro</h6>
        <v-text-field
          v-model="filters.search"
          label="Reference ou numero"
          solo
          small
          clearable
        ></v-text-field>
      </v-col>
      <!-- Type (Select) -->
      <v-col cols="12" md="4" class="pb-0 mb-0">
        <h6>Type</h6>
        <v-select
          v-model="filters.type"
          :items="types"
          label="Type"
          solo
          small
          clearable
        ></v-select>
      </v-col>

      <!-- Source (Select) -->
      <v-col cols="12" md="4" class="pb-0 mb-0">
        <h6>Moyen de paiement</h6>
        <v-select
          v-model="filters.source"
          label="Source"
          :items="means_paiements"
          item-text="_name"
          item-value="_id"
          solo
          small
          clearable
        ></v-select>
      </v-col>

      <date-range-picker
        @update:dateRange="handleDateRangeUpdate"
        ref="dateRangePicker"
      />
      <v-col cols="12" md="6" class="text-right mb-0 pb-0 pt-5 mt-5">
        <v-btn
          @click="resetFilters"
          small
          color="secondary"
          class="mr-4 mb-0 pb-0"
          >Reinitialiser</v-btn
        >
        <v-btn
          @click="applyDownload()"
          small
          depressed
          class="btn-download mr-4 mb-0 pt-0"
          :loading="downloading"
        >
          <v-icon small>mdi mdi-microsoft-excel</v-icon> Télécharger CSV
        </v-btn>
        <v-btn type="submit" small color="primary" class="mb-0 pb-0"
          >Filtrer</v-btn
        >
      </v-col>
    </v-row>

    <!-- Apply Filters Button -->
    <v-row> </v-row>
  </v-form>
</template>

<script>
import { mapState } from "vuex/dist/vuex.common.js";
import dateRangePicker from "./dateRangePicker.vue";
export default {
  components: { dateRangePicker },
  /*  watch: {
    // if download type update use function applyDownload
    download_type: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.applyDownload();
      }
    },
  }, */
  props: ["downloading"],
  data() {
    return {
      loading: true,
      show: false,
      download_type: null,
      filters: {
        type: null,
        source: null,
        search: null,
        date_created: null, // Array for date range [startDate, endDate]
      },
      types: ["DEBIT", "CREDIT"],
      sources: ["MTN", "MOOV AFRICA", "VISA_MASTERCARD"],
      download: [
        { type: "xlsx", label: "Télécharger xlsx" },
        { type: "csv", label: "Télécharger csv" },
      ],
      dateMenu: false,
    };
  },
  computed: {
    ...mapState("means_paiements/", ["means_paiements"]),
    dateRangeText() {
      if (this.filters.date_created && this.filters.date_created.length === 2) {
        const [start, end] = this.filters.date_created;
        return `${start} to ${end}`;
      }
      return "";
    },
  },
  methods: {
    initializeFiltersFromURL() {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has("search")) {
        this.filters.search = urlParams.get("search");
      }

      if (urlParams.has("type")) {
        const typeParam = urlParams.get("type");
        if (this.types.includes(typeParam)) {
          this.filters.type = typeParam;
        }
      }

      if (urlParams.has("source")) {
        const sourceParam = urlParams.get("source");
        if (this.sources.includes(sourceParam)) {
          this.filters.source = sourceParam;
        }
      }

      const startDate = urlParams.get("start_date");
      const endDate = urlParams.get("end_date");
      if (startDate && endDate) {
        this.filters.date_created = {
          start: startDate,
          end: endDate,
        };
      }
    },
    constructURLWithFilters() {
      const queryParams = new URLSearchParams();
      if (this.filters.type) {
        queryParams.append("type", this.filters.type);
      }
      if (this.filters.source) {
        queryParams.append("source", this.filters.source);
      }
      if (this.filters.search) {
        queryParams.append("search", this.filters.search);
      }
      if (this.filters.date_created) {
        const { start, end } = this.filters.date_created;

        if (start) {
          queryParams.append("start_date", start);
        }

        if (end) {
          queryParams.append("end_date", end);
        }
      }
      const fullURL = `?${queryParams.toString()}`;

      return fullURL;
    },
    handleDateRangeUpdate(newRange) {
      this.filters.date_created = newRange;
    },
    // Method to apply filters
    applyDownload() {
      this.$emit("update:download");
    },
    // Method to apply filters
    applyFilters() {
      const urlWithFilters = this.constructURLWithFilters();
      this.$emit("update:filter_url", { filter_url: urlWithFilters });
      window.history.pushState({}, "", urlWithFilters);
    },
    // Method to reset filters
    resetFilters() {
      this.filters = {
        type: null,
        source: null,
        search: null,
        date_created: null,
      };
      this.$refs.dateRangePicker.resetDate();
      this.show = false;
    },
  },
};
</script>

<style scoped>
.btn-filter {
  background-color: white !important;
  color: black !important;
}
.btn-filter .v-btn__content {
  color: black !important;
}
.btn-download {
  background-color: transparent !important;
  border: 1px solid #545454;
  color: #545454 !important;
}
.btn-download .v-btn__content {
  color: #545454 !important;
}
</style>
